import { MasterDialog } from "#common/Dialog/Dialog"
import { useApi } from "#hooks/useApi"
import { vacationIdGet } from "#vacation/services/api"
import HistoryIcon from "@mui/icons-material/History"
import {
	Box,
	Button,
	Divider,
	List,
	ListItem,
	ListItemText,
	Paper,
	Typography,
} from "@mui/material"
import React, { Fragment, useMemo } from "react"

export default function VacationHistoryDialog({ id }) {
	const [open, setOpen] = React.useState(false)
	const params = useMemo(() => ({ id, params: { history: true } }), [id])
	const { data, loading, error } = useApi(vacationIdGet, { autoFetch: open, params })
	// if (loading) return <div>Loading...</div>

	return (
		<Fragment>
			<Button
				variant="outlined"
				size="small"
				startIcon={<HistoryIcon />}
				onClick={() => setOpen(true)}
			>
				ver historial
			</Button>
			<MasterDialog
				{...{
					title: "Historial de solicitud de vacaciones",
					open,
					setOpen,
					maxWidth: "sm",
				}}
			>
				{loading && <div>Loading...</div>}
				{error && <div>{error?.response?.data?.message}</div>}
				{!loading && !error && <History data={data?.data} />}
			</MasterDialog>
		</Fragment>
	)
}

const History = ({ data }) => {
	return (
		<Box sx={{ maxWidth: 800, margin: "0 auto", padding: 0 }}>
			<Paper elevation={3} sx={{ padding: 0 }}>
				<List>
					{data.map((entry, index) => (
						<React.Fragment key={entry.id}>
							<ListItem alignItems="flex-start" sx={{ padding: 2 }}>
								<ListItemText
									sx={{ marginLeft: 2 }}
									primary={
										<Box
											sx={{
												display: "flex",
												alignItems: "center",
												gap: 1,
												mb: 1,
											}}
										>
											<Typography variant="h6" component="span">
												{entry.created_by_name}
											</Typography>
											<Typography variant="body2" color="text.secondary"></Typography>
										</Box>
									}
									secondary={
										<Box>
											<Typography variant="body2" color="text.primary" sx={{ mb: 1 }}>
												{entry.created_at}
											</Typography>
											<Typography variant="body2" color="text.primary" sx={{ mt: 1 }}>
												{entry.action}
											</Typography>
											{entry.comment && (
												<Typography
													variant="body2"
													color="text.primary"
													sx={{ mt: 1, whiteSpace: "pre-line" }}
												>
													{entry.comment}
												</Typography>
											)}
										</Box>
									}
								/>
							</ListItem>
							{index < data.length - 1 && <Divider variant="inset" component="li" />}
						</React.Fragment>
					))}
				</List>

				{data.length === 0 && (
					<Box sx={{ textAlign: "center", py: 4 }}>
						<Typography variant="body1" color="text.secondary">
							No hay entradas en el historial
						</Typography>
					</Box>
				)}
			</Paper>
		</Box>
	)
}
